export default __webpack_public_path__ + "static/N0307-d26b52f34a86f49c897ea0f1d6121f7c.png";